type Prop = {
    number: number
}

const ProductsSkeleton = ({ number }: Prop) => {
    return (
        <div className='productsCont'>

            {[...Array(number)].map((_, i) => (
                <div className='eachproduct skeleton' key={i}>

                    <div className='imageCont'>
                    </div>

                    <div className='textCont'>
                        <div className='productName'></div>

                        <div className='productPrice'>

                            <div className='currentPrice'></div>

                        </div>

                        <div className='productReception'>

                        </div>

                    </div>

                </div>
            ))}






        </div>
    )
}

export default ProductsSkeleton;